import { render, staticRenderFns } from "./SwayOfferProofApprovalCard.vue?vue&type=template&id=dc139fa6&scoped=true&"
import script from "./SwayOfferProofApprovalCard.vue?vue&type=script&lang=js&"
export * from "./SwayOfferProofApprovalCard.vue?vue&type=script&lang=js&"
import style0 from "./SwayOfferProofApprovalCard.vue?vue&type=style&index=0&id=dc139fa6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc139fa6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VCol,VDivider,VImg,VRow,VSelect})
